import {
  Summarize as SummarizeIcon,
  EditNote as EditNoteIcon,
  Search as SearchIcon,
  Send as SendIcon,
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
  AssignmentTurnedIn as AssignmentTurnedInIcon,
  AccessTime as AccessTimeIcon,
  Flag as FlagIcon,
  PendingActions as PendingActionsIcon,
} from "@mui/icons-material";

export const STATUS_DEFAULT = "all";

export const STATUS_OPTIONS_PUBLIC = [
  { label: "Todos", value: STATUS_DEFAULT, color: "primary", icon: <SummarizeIcon sx={{ color: "white", fontSize: 40 }} /> },
  { label: "Firmado", value: "signed", color: "success", icon: <AssignmentTurnedInIcon sx={{ color: "white", fontSize: 40 }} /> },
  { label: "Vencido", value: "expired", color: "default", icon: <CancelIcon sx={{ color: "white", fontSize: 40 }} /> },
  { label: "Terminado", value: "finished", color: "success", icon: <FlagIcon sx={{ color: "white", fontSize: 40 }} /> },
  { label: "Por vencer", value: "next_to_expired", color: "warning", icon: <AccessTimeIcon sx={{ color: "white", fontSize: 40 }} /> },
];

export const STATUS_OPTIONS_PRIVATE = [
  { label: "Todos", value: "all", color: "#000000", icon: <SummarizeIcon sx={{ color: "white", fontSize: 40 }} /> },
  { label: "Borrador", value: "draft", color: "#616161", icon: <EditNoteIcon sx={{ color: "white", fontSize: 40 }} /> },
  { label: "Analizado", value: "process", color: "#0091ea", icon: <SearchIcon sx={{ color: "white", fontSize: 40 }} /> },
  { label: "Enviado a Rector", value: "sent_to_rector", color: "#ff8f00", icon: <SendIcon sx={{ color: "white", fontSize: 40 }} /> },
  { label: "Aprobado por Rector", value: "approved_by_rector", color: "#388e3c", icon: <CheckCircleIcon sx={{ color: "white", fontSize: 40 }} /> },
  { label: "Rechazado por Rector", value: "rejected_by_rector", color: "#d84315", icon: <CancelIcon sx={{ color: "white", fontSize: 40 }} /> },
  { label: "Enviado a Solicitante", value: "sent_to_applicant", color: "#ff8f00", icon: <SendIcon sx={{ color: "white", fontSize: 40 }} /> },
  { label: "Aprobado por Solicitante", value: "approved_by_applicant", color: "#388e3c", icon: <CheckCircleIcon sx={{ color: "white", fontSize: 40 }} /> },
  { label: "Rechazado por Solicitante", value: "rejected_by_applicant", color: "#d84315", icon: <CancelIcon sx={{ color: "white", fontSize: 40 }} /> },
  { label: "Pendiente de firma", value: "wait_to_sign", color: "#3F51B5", icon: <PendingActionsIcon sx={{ color: "white", fontSize: 40 }} /> },
  { label: "Firmado", value: "signed", color: "#388e3c", icon: <AssignmentTurnedInIcon sx={{ color: "white", fontSize: 40 }} /> },
  { label: "Vencido", value: "expired", color: "#212121", icon: <CancelIcon sx={{ color: "white", fontSize: 40 }} /> },
  { label: "Terminado", value: "finished", color: "#1b5e20", icon: <FlagIcon sx={{ color: "white", fontSize: 40 }} /> },
  { label: "Por vencer", value: "next_to_expired", color: "#c62828", icon: <AccessTimeIcon sx={{ color: "white", fontSize: 40 }} /> },
];

